import React, { useEffect, useMemo, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import FilterDispatch from '../../contexts/filterDispatch';
import filterActions from '../../actions/filter.actions';

import Select from './Select';
import style from './Filter.module.css';

const Filter = React.memo(({ history, options, defaultFilter }) => {
  const params = useMemo(() => new URLSearchParams(history.location.search), [history.location.search]);

  const queryFilter = params.get('clientType');

  const [filter, setFilter] = useState(queryFilter || defaultFilter);
  const [search, setSearch] = useState(false);

  const dispatch = useContext(FilterDispatch);

  const handleFilterChange = event => {
    setFilter(event.target.value);
    setSearch(true);
  };

  useEffect(() => {
    if (search) {
      params.set('clientType', filter);
      params.set('page', 0);

      history.push(`${history.location.pathname}?${params.toString()}`);
      setSearch(false);

      dispatch({
        type: filterActions.FILTER_CHANGED_SUCCESS,
      });
    }
  }, [search, params, filter, dispatch, history]);

  return (
    <section className={style.filter}>
      Filter:&nbsp;
      <Select value={filter} onChange={handleFilterChange} options={options} />
    </section>
  );
});

Filter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      defaultValue: PropTypes.bool,
    }),
  ).isRequired,
  defaultFilter: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};

export default Filter;
